import * as React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

export const withTooltip = <T extends object>(
	WrappedComponent: React.ComponentType<T>,
) => {
	const ComponentWithTooltip: React.FC<
		T &
			Partial<{
				tooltip: string;
				tooltipProps: React.ComponentProps<typeof Tooltip>;
				tooltipContentProps: React.ComponentProps<typeof TooltipContent>;
			}>
	> = ({ tooltip, tooltipContentProps, tooltipProps, ...props }) => {
		if (tooltip)
			return (
				<Tooltip {...tooltipProps}>
					<TooltipTrigger asChild>
						<WrappedComponent {...(props as T)} />
					</TooltipTrigger>
					<TooltipContent sideOffset={10} {...tooltipContentProps}>
						<p>{tooltip}</p>
					</TooltipContent>
				</Tooltip>
			);
		return <WrappedComponent {...(props as T)} />;
	};

	return ComponentWithTooltip;
};
